export const PARTNER_IDS = {
  premium: 1305,
  GHC: 1186,
  mosgortour: 1297,
  alfa: 1220,
  sutochno: 1168,
  tbank: 1190,
  travelbelka: 118,
  cosmos_travel: 1320,
} as const;

export type PartnerCode = keyof typeof PARTNER_IDS;
